import React from "react";
import { ChevronDown } from "lucide-react";

const labelCls = "block text-[#C8CED8] text-xs tracking-widest uppercase mb-2";
export const fieldCls =
  "w-full h-12 rounded-md bg-[#05070B] border border-[#1E90FF]/20 px-3 text-base md:text-sm text-[#F3F6FA] placeholder:text-[#A1A7B3] focus:outline-none focus:ring-2 focus:ring-[#1E90FF]/60 focus:border-[#1E90FF]";

const NativeSelect = ({ id, label, placeholder, options, value, onChange }) => (
  <div>
    <label htmlFor={id} className={labelCls}>{label}</label>
    <div className="relative">
      <select id={id} data-testid={id} value={value} onChange={(e) => onChange(e.target.value)}
        style={{ colorScheme: "dark" }} className={`${fieldCls} appearance-none pr-12`}>
        <option value="">{placeholder}</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      <ChevronDown aria-hidden="true" size={18} className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#C8CED8]" />
    </div>
  </div>
);

const Segmented = ({ id, label, options, value, onChange }) => (
  <div role="radiogroup" aria-label={label}>
    <span className={labelCls}>{label}</span>
    <div className="grid grid-cols-2 gap-2">
      {options.map((o) => (
        <button key={o.value} type="button" role="radio" aria-checked={value === o.value}
          data-testid={`${id}-${o.value}`} onClick={() => onChange(o.value)}
          className={`h-12 rounded-md border text-sm font-semibold transition-colors ${
            value === o.value
              ? "bg-[#1E90FF]/15 border-[#1E90FF] text-[#F3F6FA]"
              : "bg-[#05070B] border-[#1E90FF]/20 text-[#A1A7B3] hover:border-[#1E90FF]/50"
          }`}>
          {o.label}
        </button>
      ))}
    </div>
  </div>
);

// Coaching-specific fields shared by the coaching page form and the main contact form.
export const CoachingFields = ({ t, values, onChange, idPrefix, showPath = false }) => (
  <div className="grid md:grid-cols-2 gap-5">
    {showPath && (
      <NativeSelect id={`${idPrefix}-path`} label={t.pathLabel} placeholder={t.pathPlaceholder}
        options={t.pathOptions} value={values.coaching_path} onChange={onChange("coaching_path")} />
    )}
    <NativeSelect id={`${idPrefix}-level`} label={t.levelLabel} placeholder={t.levelPlaceholder}
      options={t.levelOptions} value={values.level} onChange={onChange("level")} />
    <Segmented id={`${idPrefix}-language`} label={t.languageLabel} options={t.languageOptions}
      value={values.session_language} onChange={onChange("session_language")} />
    <Segmented id={`${idPrefix}-format`} label={t.formatLabel} options={t.formatOptions}
      value={values.session_format} onChange={onChange("session_format")} />
    {values.session_format === "in-person" && (
      <div className="md:col-span-2">
        <label htmlFor={`${idPrefix}-location`} className={labelCls}>{t.locationLabel}</label>
        <input id={`${idPrefix}-location`} data-testid={`${idPrefix}-location`} value={values.location}
          onChange={(e) => onChange("location")(e.target.value)} placeholder={t.locationPlaceholder}
          maxLength={120} className={fieldCls} />
      </div>
    )}
  </div>
);

export const emptyCoachingValues = (language = "") => ({
  coaching_path: "",
  level: "",
  session_language: language,
  session_format: "online",
  location: "",
});

export default CoachingFields;
